/** Pathnames that may prefix App Router / next-intl URLs (strip before matching `activeRouts`). */
const ROUTING_LOCALE_SEGMENTS = ["en", "uk-ua", "vi", "ru", "es", "fr", "tr", "pt", "ar"];

function stripRoutingLocalePrefix(pathname: string): string {
  for (const loc of ROUTING_LOCALE_SEGMENTS) {
    if (pathname === `/${loc}`) return "/";
    if (pathname.startsWith(`/${loc}/`)) {
      return pathname.slice(`/${loc}`.length) || "/";
    }
  }
  return pathname;
}

export const getCurrentPath = (routes: string[] | undefined) => {
  if (typeof window === "undefined" || !routes?.length) {
    return false;
  }

  const router = window?.next?.router;
  if (router?.state?.route != null) {
    const path = `${router?.basePath ?? ""}${router.state.route}`;
    return routes.includes(path);
  }

  const pathname = stripRoutingLocalePrefix(window.location?.pathname ?? "");
  return routes.some((r) => {
    if (!r) return false;
    return pathname === r || pathname.startsWith(`${r}/`);
  });
};
